export const pushAnalyticsUpdateEvent = (uuid: string) => {
  /** stand-alone event with only this specified data  */
  window.dataLayer = window.dataLayer || [];

  window.dataLayer.push({
    event: 'update_user_uuid',
    UserUUID: uuid,
  });
};
